import { MuiTypography } from '@/features/shared/material-ui';
import TwoColumnContent from '@/features/shared/TwoColumnContent';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo } from 'react';
import { HeaderContent } from './HeaderContent';
import { MainContent } from './MainContent';
import { PressCenterResourceProps } from './PressCenterResource.interface';
import useStyles from './PressCenterResource.styles';
import { SideContent } from './SideContent';

const PressCenterResource = ({
  content,
  resources,
  dynamicContent = [],
  contentButtons,
  theme = Theme.light,
}: Br.PropsWithContentButtons<PressCenterResourceProps>) => {
  const classes = useStyles({});

  const { listTitle: title, listSuperheading: superheading } = content || {};

  const headerContentProps = {
    title,
    theme,
  };

  const mainContentProps = {
    content,
    dynamicContent,
    theme,
  };

  const sideContentProps = {
    resources,
    theme,
  };

  const rootClasses = clsx(classes.root, `${theme}-theme`);

  return (
    <article className={rootClasses} data-testid="press-center--container">
      {superheading && (
        <MuiTypography
          variant="overline"
          component="h6"
          color="inherit"
          className={classes.superheading}
        >
          {superheading}
        </MuiTypography>
      )}
      <TwoColumnContent
        columnRatio="65-35"
        leftColumn={
          <>
            <header>
              <HeaderContent {...headerContentProps} />
            </header>
            <section>
              <MainContent {...mainContentProps} contentButtons={contentButtons} />
            </section>
          </>
        }
        rightColumn={<SideContent {...sideContentProps} contentButtons={contentButtons} />}
      />
    </article>
  );
};

export default memo(PressCenterResource);
